/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EsitoImportazioneEsercente } from './esito-importazione-esercente';
import { MotivoSaltoImportazioneEsercente } from './motivo-salto-importazione-esercente';


export interface EsercenteImportazioneEsitoDTO { 
    pratica_origine_id?: string;
    esito?: EsitoImportazioneEsercente;
    motivo?: MotivoSaltoImportazioneEsercente;
    errore_codice?: string;
    pratica_creata_id?: string;
    codice_pratica?: string;
    mancanti?: Array<string>;
}



